import { RedirectLoginOptions } from "@auth0/auth0-react";
import {ErrorData,ErrorType} from "./types";

let globalLoginWithRedirect: ((opts: RedirectLoginOptions) => Promise<void>) | undefined = undefined;

const ErrorHandler = {
  setGlobalLoginRedirectHandler(loginHandler: (opts: RedirectLoginOptions) => Promise<void>) {
    globalLoginWithRedirect = loginHandler;
  },

  getHttpStatus: function(err : any) : number{
    let statusCode : number = 0;
    if( err.status ){
      statusCode = err.status;
    }
    else if( err.response && err.response.status ){
      statusCode = err.response.status;
    }
    else if( err.status === null ){
      statusCode = 500;
    }
    else{
      //This is a javascript error
      statusCode = 500;
    }
    return statusCode;
  },

  isNetworkError: function(err : any): boolean {
    return err && err.message && err.message.toLowerCase() === "network error";
  },

  handleLoggedOutError: function (error: any, loginWithRedirect?: () => void): boolean {
    const statusCode = this.getHttpStatus(error);
    if (statusCode === 403 || statusCode === 401) {
      window.alert("Your session has expired. You will be redirected to the login page.");
      loginWithRedirect();
      return true;
    }
    return false;
  },

  handleAuthError(error: any, setError?: (err: any) => void): boolean {
    const redirectFn = globalLoginWithRedirect
      ? () => {
          globalLoginWithRedirect({
            appState: { returnTo: window.location.pathname }
          });
        }
      : undefined;

    const isLoggedOut = ErrorHandler.handleLoggedOutError(error, redirectFn);

    if (!isLoggedOut && setError) {
      setError(error);
    }

    return isLoggedOut;
  },

  getErrorMessage : function(error : any) : ErrorData {
    const errorMessage : ErrorData = {
      msg : "",
      type : ErrorType.exception
    };

    if (error.response) {
      const statusCode = this.getHttpStatus(error);
      if( statusCode >= 500 ){
        if( error.response.data ){
          if( typeof error.response.data === 'string' && error.response.data.includes("ECONNREFUSED")){
            errorMessage.msg = "There was an error connecting to our servers";
          }
          else {
            errorMessage.msg = "There was an error in our servers.";
          }
        }
        else {
          errorMessage.msg = error.message;
        }
        errorMessage.type = ErrorType.exception;
      }
      else if( statusCode >= 400 ){
        if( error.response.data ){
          errorMessage.msg = "There was an error sending data to our servers.";
        }
        else {
          errorMessage.msg = error.message;
        }
        errorMessage.type = ErrorType.exception;
      }
      else if( statusCode >= 300 ){
        if( error.response.data ){
          errorMessage.msg = "There was an error with the data to our servers.";
        }
        else {
          errorMessage.msg = error.message;
        }
        errorMessage.type = ErrorType.warning;
      }
    } else if (error.request) {
      errorMessage.msg = error.message;
    } else {
      errorMessage.msg = error.message;
    }


    // const element = <AlertDismissible message={msg} serverMessage={serverMessage} variant={variant} setErrors={setErrors}/>;
    // let errorsArray = [];
    // errorsArray.push(element);
    // setErrors(errorsArray);
    return errorMessage;
  }

};

export default ErrorHandler;